import React, { useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  FolderIconBlue,
  ArrowUpRightBlue,
  MasterCard,
  AmountYouWillEarnCard,
  ForwardArrow,
} from "../../../../constant/imagePath";
import { Container } from "react-bootstrap";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./StartWorkAndGetPaidMobile.module.css";
import { Input } from "../../../../stories/Input/Input";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import JustToNotifyYou from "../../../Modals/CoachFlow/OnBoarding/JustToNotifyYou/JustToNotifyYou";
import HowDoesPricingWork from "../../../Modals/CoachFlow/OnBoarding/HowDoesPricingWork/HowDoesPricingWork";
import HowDoesPricingWorkMobile from "../../../Modals/CoachFlow/OnBoarding/HowDoesPricingWork/HowDoesPricingWorkMobile";
import CheckBoxStyles from "../../../../stories/Checkbox/Checkbox.module.css";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";

export default function StartWorkAndGetPaidMobile({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(state => state.onBoardingReducer.price)
  const [agreedToPolicy, setAgreedToPolicy] = useState(getDataFromRedux?.agreedToPolicy ? getDataFromRedux?.agreedToPolicy :[]);
  const [priceForAnHour, setPriceForAnHour] = useState(getDataFromRedux?.priceForAnHour ? getDataFromRedux?.priceForAnHour : 45);

  const [paymentMethods, setPaymentMethods] = useState([
    { icon: MasterCard, title: "Credit or Debit Card" },
  ]);
  const [modal, setModal] = useState(false);

  function saveDataIntoRedux() {
    dispatch(setPersonalData('price', {priceForAnHour, agreedToPolicy}))

  }

  return (
    <div className={classes.StartWorkAndGetPaid}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={'66.6%'} />
      </div>

      <style jsx>
        {`
          .${CheckBoxStyles.checkboxWithLabel} label {
            display: unset;
          }
        `}
      </style>
      <Row className={`g-0 ${classes.row}`}>
        <Col md={12} className={` ${classes.innerContainer}`}>
        <Col md={12}>
          <h3
            style={{
              ...Fonts.h3,
              color: Colors.neutralShadesOfNero,
              fontSize: "24px",
              lineHeight: "32px",
            }}
          >
            Start work and get paid
          </h3>

          <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
            Set your lesson price for your 1-on-1 lesson
          </p>
        </Col>
        {/* Lesson Price Card */}
        <Col md={12} className={`${[classes.mt24].join(" ")}`}>
          <div className={classes.lessonInputAndPerHour}>
            <Input
              placeholder=""
              type="number"
              state={priceForAnHour}
              setter={(e) => {
                if (e.length < 5) {
                  setPriceForAnHour(e)
                }
              }}

              label={
                <p
                  style={{
                    ...Fonts.input2,
                    lineHeight: "16px",
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Set the price for 1 hour lessons{" "}
                  <span style={{ color: Colors.neutralShadesOfDimGray }}>
                    USD
                  </span>
                </p>
              }
            />
            <p
              className={classes.perHour}
              style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}
            >
              /1 hour
            </p>
          </div>
        </Col>
        <Col sm={12}>
          <div
            className={classes.amountBox}
            style={{ background: Colors.neutralShadesOfNero }}
          >
            <div>
              <p style={{ ...Fonts.h9, color: Colors.white }}>
                Amount you’ll earn for 1 hour lessons
              </p>
            </div>
            <div>
              <p
                style={{
                  ...Fonts.h3,
                  fontSize: "24px",
                  lineHeight: "32px",
                  color: Colors.white,
                }}
              >
                ${priceForAnHour}
              </p>
            </div>
          </div>
        </Col>
        <Col sm={12}>
          <p
            className={`${[classes.lytesnapCharges].join(" ")}`}
            style={{
              ...Fonts.b2,
              fontFamily: "inter-400",
              color: Colors.neutralShadesOfNero,
            }}
          >
            <span style={{ ...Fonts.b2, fontFamily: "inter-600" }}>
              Lytesnap charges 10%
            </span>{" "}
            of your listed lesson price
          </p>
          <LinkButtonWithIcon
            text={"System fee info"}
            primary={true}
            rightIcon={ArrowUpRightBlue}
            iconStyle={{ margin: "0px" }}
          />
        </Col>
        {/* Payout Methods */}
        <Col md={12} className={classes.payoutMethodsSection}>
          <h4
            style={{
              ...Fonts.h4,
              color: Colors.neutralShadesOfNero,
              fontSize: "20px",
              lineHeight: "28px",
            }}
          >
            Payout methods
          </h4>
          <p className={classes.firstLine}>
            To get paid, you need to set up a payout method. Our secure payment
            system supports several payout methods, which can be set up below.{" "}
            <LinkButtonWithIcon text={"Go to FAQ."} primary={true} />
          </p>
          <p className={classes.secondLine}>
            Lytesnap releases payouts about 24 hours after the end of the
            lesson. The time it takes for the funds to appear in your account
            depends on your payout method.
          </p>
        </Col>
        <Col md={12} className={classes.mt24}>
          <ul className={classes.paymentMethods}>
            {paymentMethods?.map((item) => {
              return (
                <li
                  style={{
                    border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  }}
                >
                  <img src={item?.icon} className={classes.logo} />
                  <span
                    style={{
                      ...Fonts.h7,
                      color: Colors.neutralShadesOfNero,
                      fontFamily: "inter-600",
                      lineHeight: "24px",
                    }}
                  >
                    {item?.title}
                  </span>
                  <img src={ForwardArrow} className={classes.forwardArrow} />
                </li>
              );
            })}
          </ul>
        </Col>
        {/* I have read and agreed to the pricing policy */}
        <Col md={12}>
          <div className={`d-flex align-items-center ${[classes.mt32].join(" ")}`}>
            <Checkbox
              label={"I have read and agreed to the"}
              value={agreedToPolicy}
              setValue={setAgreedToPolicy}
            />
            &nbsp;
            <p style={{ ...Fonts.p1, color: Colors.mainBlue, textDecoration: "underline", }} onClick={() => setModal(true)}>
              Pricing policy</p>
          </div>
        </Col>
        </Col>

        {/* Btns Col */}

        <Col
          md={12}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          className={`${[classes.btnsCol].join(" ")}`}
        >
          <div className={classes.btnsBox}>
            <LinkButtonWithIcon
              text={"Go Back"}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
                width: "max-content",
                height: "56px",
              }}
              onClick={() => {
                stepForwardAndBackward(2, 3)}}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ ...Fonts.b1, width: "156px", height: "56px" }}
              onClick={() => {
                saveDataIntoRedux()
                stepForwardAndBackward(3, 1)}}
            />
          </div>
        </Col>

      </Row>
      {/* Just To Notify Modal */}
      {/* <JustToNotifyYou show={modal} setShow={setModal} /> */}
      {/* How Does Pricing Work */}
      <HowDoesPricingWorkMobile show={modal} setShow={setModal} />
    </div>
  );
}
